import React, { useState } from 'react'
import { LayoutCP } from 'submodules/nerit-framework-ui/common/components/screen/layout/layout/LayoutCP'
import { HeaderCP } from 'submodules/nerit-framework-ui/common/components/screen/layout/header/HeaderCP'
import { TableFieldsRegulationCP } from 'modules/fields/components/tables/table-fields-regulation/TableFieldsRegulationCP'
import { TableUtils } from 'submodules/nerit-framework-ui/common/components/table/utils/TableUtils'
import { ButtonGroupCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonGroupCP'
import { ButtonModalFieldRegulationCP } from 'modules/fields/components/buttons/button-modal-field-regulation/ButtonModalFieldRegulationCP'
import { FiltersFieldRegulationCP } from 'modules/fields/components/filters/filters-field-regulation/FiltersFieldRegulationCP'
import { useFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/UseFormStateManager'
import { FieldRegulationFiltersFormModel } from 'modules/fields/components/filters/filters-field-regulation/inner/FieldRegulationFiltersFormModel'

export function ScreenFieldRegulation(): JSX.Element {

    const [formModel] = useState<FieldRegulationFiltersFormModel>(new FieldRegulationFiltersFormModel())
    const formStateManager = useFormStateManager(formModel)

    const [shouldLoadData, setShouldLoadData] = useState<number>(TableUtils.getReloadNumber())

    return (
        <LayoutCP
            header={
                <HeaderCP title={'Biblioteca de Norma'}>
                    <ButtonGroupCP mode={'separeted'}>
                        <ButtonModalFieldRegulationCP
                            onSave={() => setShouldLoadData(TableUtils.getReloadNumber())}
                        />
                    </ButtonGroupCP>
                </HeaderCP>
            }
            overflowVertical={true}
            content={
                <>
                    <FiltersFieldRegulationCP
                        formStateManager={formStateManager}
                        onFilter={() => setShouldLoadData(TableUtils.getReloadNumber)}
                    />

                    <TableFieldsRegulationCP
                        filtersDto={FieldRegulationFiltersFormModel.formatDto(formStateManager)}
                        shouldLoadData={shouldLoadData}
                    />
                </>
            }
        />
    )
}
